import countryList from "constants/countryList";

// Legacy country code mapping (deprecated).
// Single source of truth is now `src/constants/countryList.ts`.
//
// const countryCodes = {
//   US: "+1",
//   CA: "+1",
//   DO: "+1",
//   RU: "+7",
//   EG: "+20",
//   ZA: "+27",
//   GR: "+30",
//   NL: "+31",
//   BE: "+32",
//   FR: "+33",
//   ES: "+34",
//   HU: "+36",
//   IT: "+39",
//   CH: "+41",
//   AT: "+43",
//   GB: "+44",
//   DK: "+45",
//   SE: "+46",
//   NO: "+47",
//   DE: "+49",
//   MX: "+52",
//   AR: "+54",
//   BR: "+55",
//   CL: "+56",
//   CO: "+57",
//   MY: "+60",
//   AU: "+61",
//   ID: "+62",
//   PH: "+63",
//   NZ: "+64",
//   SG: "+65",
//   TH: "+66",
//   KR: "+82",
//   JP: "+81",
//   VN: "+84",
//   CN: "+86",
//   TR: "+90",
//   IN: "+91",
//   PK: "+92",
//   MM: "+95",
//   IQ: "+964",
//   NG: "+234",
//   PT: "+351",
//   IE: "+353",
//   IS: "+354",
//   FI: "+358",
//   MC: "+377",
//   PA: "+507",
//   HK: "+852",
//   MO: "+853",
//   KH: "+855",
//   TW: "+886",
//   SA: "+966",
//   AE: "+971",
//   IL: "+972",
//   QA: "+974",
//   MN: "+976",
//   NP: "+977",
// };

export const getCountryInitial = (countryCode: string) => {
  const match = countryList.find(
    (country: any) => country.countryCode === countryCode
  );
  return match?.key ? String(match.key).toUpperCase() : null;
};

const parseCallingCodeNumber = (callingCode: string) => {
  const n = Number.parseInt(String(callingCode).replace(/[^\d]/g, ""), 10);
  return Number.isFinite(n) ? n : 0;
};

export const getCountryCodeList = (t: (key: string) => string) => {
  const getDisplayName = (country: any) => {
    const i18nKey = `utils.countryCode.${String(country.key).toUpperCase()}`;
    const translated = t(i18nKey);
    // i18next usually returns the key when missing; fallback to the raw name.
    return translated && translated !== i18nKey ? translated : country.text;
  };

  return [...countryList]
    .filter((country: any) => Boolean(country?.countryCode))
    .sort((a: any, b: any) => {
      const aNum = parseCallingCodeNumber(a.countryCode);
      const bNum = parseCallingCodeNumber(b.countryCode);
      if (aNum !== bNum) return aNum - bNum;
      return getDisplayName(a).localeCompare(getDisplayName(b));
    })
    .map((country: any) => {
      const name = getDisplayName(country);
      return {
        text: `${name}\t(${country.countryCode})`,
        value: country.countryCode,
      };
    });
};
